<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>代理</el-breadcrumb-item>
			<el-breadcrumb-item>商品申请</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="margin-t-20 flex justify-content-s-b">
			<el-form :inline="true" :model="queryForm" size="small">
				<el-form-item>
					<el-input v-model="queryForm.keyword" placeholder="请输入商品名称/会员ID"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryForm.status" placeholder="选择城市">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary">查询</el-button>
					<el-button type="infor">刷新</el-button>
				</el-form-item>
			</el-form>

			<div>
				<el-button @click="handleAdd" type="primary" size="small">+ 新增</el-button>
			</div>
		</div>

		<div>
			<el-table :data="tableData" border style="width: 100%" max-height="500">
				<el-table-column type="index" label="序号" width="80">
				</el-table-column>
				<el-table-column label="商品信息">
					<template>
						商品信息
					</template>
				</el-table-column>
				<el-table-column prop="name" label="申请人">
				</el-table-column>
				<el-table-column prop="name" label="联系方式">
				</el-table-column>
				<el-table-column prop="name" label="城市">
				</el-table-column>
				<el-table-column prop="name" label="会员ID">
				</el-table-column>
				<el-table-column label="审核状态">
					<template>
						审核状态
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template>
						<el-button type="primary" size="small">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="margin-t-10 flex">
			<el-pagination background layout="prev, pager, next, jumper" :total="total"
				:current-page.sync="queryForm.page" @current-change="handleCurrentPageChange">
			</el-pagination>
			<el-button size="small">确定</el-button>
		</div>

		<el-dialog title="选择商品" :visible.sync="showDialog" width="40%" :before-close="closeDialog">
			<el-table :data="tableData" border style="width: 100%" max-height="300">
				<el-table-column type="index" label="序号" width="80">
				</el-table-column>
				<el-table-column label="商品图片">
					<template>
						商品图片
					</template>
				</el-table-column>
				<el-table-column prop="name" label="商品名">
				</el-table-column>
				<el-table-column prop="name" label="商品价格">
				</el-table-column>
			</el-table>

			<span slot="footer">
				<el-button @click="closeDialog">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'CommodityApply',
		data() {
			return {
				showDialog: false,
				queryForm: {
					page: 1,
				},
				total: 0,
				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}]
			}
		},
		methods: {
			handleCurrentPageChange() {

			},
			handleAdd() {
				this.showDialog = true
			},
			handleSubmit() {

			},

			closeDialog() {
				this.showDialog = false
			},
		}
	}
</script>

<style lang="less" scoped>
</style>
